import { arrayToMap } from "../util";

// nameは未使用
// urlを含む項目は未使用

const list = [
  {
    // biztelMode がfalseの時は、すべてこのcontactTypeとみなされる
    slug: "all_main",
    // #00
    phoneNumber: "0120-52-4185",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始を除く月～日曜日",
    showCorporateLink: true,
    showForm: true,
    showChat: true,
  },
  {
    // 特に振り分けない電話番号表示
    slug: "common_main",
    // #00
    phoneNumber: "0120-52-4185",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始を除く月～日曜日",
  },
  {
    name: "これからご契約のお客様",
    slug: "visitor_main",
    // #00
    phoneNumber: "0120-52-4185",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始を除く月～日曜日",
    showCorporateLink: true,
    showForm: true,
    showChat: true,
  },
  {
    // TODO この項目は実際には使われておらず、直でリンクされている
    name: "ビジネスのご相談（土地活用やパートナー提携）",
    slug: "related_business",
    url: "/hello-storage/contact/?customer_kbn=2",
  },
  {
    name: "物件に関する苦情",
    slug: "related_complaint",
    // #01
    // phoneNumber: "03-6859-2474",
    showAdviceCard: true,
  },
  {
    name: "その他・ご意見",
    slug: "related_etc",
    // #01
    phoneNumber: "0120-86-3085",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始・土日祝を除く",
    showAdviceCard: true,
  },
  {
    // TODO この項目は実際には使われておらず、直でリンクされている
    name: "既に会員のお客様（マイページ）",
    slug: "member_mypage",
    url: '/mypage3/dashboard/',
  },
  {
    // TODO この項目は実際には使われておらず、直でリンクされている
    name: "解約",
    slug: "member_cancel",
    url: '/mypage3/dashboard/',
  },
  {
    // 解約画面の「お困りの方はこちら」ボタンより（未使用）
    name: "解約",
    slug: "member_cancel_aux",
    // #04
    phoneNumber: "03-6859-2473",
  },
  {
    name: "移動・追加検討中",
    slug: "member_contract",
    // #00
    phoneNumber: "0120-52-4185",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始を除く月～日曜日",
    showCorporateLink: true,
    showForm: true,
    showChat: true,
  },
  {
    name: "ご契約名義変更",
    slug: "member_profile",
    // #02
    phoneNumber: "0120-86-3085",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始・土日祝を除く",
  },
  {
    name: "支払方法変更",
    slug: "member_payment",
    // #05
    phoneNumber: "0120-86-3085",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始・土日祝を除く",
  },
  {
    name: "鍵紛失トラブル",
    slug: "member_key",
    // #03
    phoneNumber: "0120-86-3085",
    phoneDescription1: "受付時間　９：３０－１８：００",
    phoneDescription2: "※年末年始・土日祝を除く",
  },
  {
    name: "交通系ICカード利用について",
    slug: "felica_key",
    // #03
    phoneNumber: "0120-86-3085",
  },
  {
    name: "苦情・ご意見・ご感想",
    slug: "member_complaint",
    // #01
    // phoneNumber: "03-6859-2474",
    showAdviceCard: true,
  },
  {
    // TODO この項目は実際には使われておらず、直でリンクされている
    name: '法人様専用窓口',
    slug: 'business',
    url: 'https://info.arealink.co.jp/biz_contact',
  },
  {
    name: "北海道1",
    slug: "hokkaido1",
    phoneNumber: "011-811-0072",
  },
  {
    name: "北海道2",
    slug: "hokkaido2",
    phoneNumber: "011-374-6229",
  },
];

for (const contactType of list) {
  if (contactType.phoneNumber) {
    contactType.phoneUrl = 'tel:' + contactType.phoneNumber.replace(/-/g, '');
  }
}

export const data = {
  list: list,
  bySlug: arrayToMap(list, "slug"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/contactType.js